// [TODO] could this be replace by `handle` on react-router 6?
import { isFunction, get, isEmpty } from "lodash"
import ruta3 from "ruta3"
import { Types } from "../../actions/app/history"

const SUPPORT_URL = "https://support.ompnt.com/en/articles"

const router = ruta3()

// Home
router.addRoute("/:accountValue/home/resources", {
  title: "Resources",
  url: `${SUPPORT_URL}/1144438-op-home-screen-resource-selection`,
})

// Dashboard
router.addRoute("/:accountValue/dashboard", {
  title: "Trading Dashboard + AI",
  url: `${SUPPORT_URL}/12162576-ai-powered-pm-trading-dashboard-beta`,
})

// Platform
router.addRoute("/:accountValue/home/platform", {
  title: "Getting started with the OP API",
  url: `${SUPPORT_URL}/1520010-developing-with-the-omega-point-api`,
})

// Data cloud
router.addRoute("/:accountValue/home/data-cloud/*", {
  title: "Data cloud",
  url: `${SUPPORT_URL}/5318039-op-financial-data-cloud-marketplace`,
})

// Position upload
router.addRoute("/:accountValue/p/:portfolioAliasOrId/upload", {
  title: "Position upload",
  url: `${SUPPORT_URL}/2966213-upload-positions-to-a-portfolio`,
})

// Overview performance
const overviewArticle = {
  title: "Portfolio overview",
  url: `${SUPPORT_URL}/1144175-application-walkthrough#overview-screen`,
}
router.addRoute("/:accountValue/p/:portfolioAlias/overview", overviewArticle)
router.addRoute("/:accountValue/p/:portfolioAlias/overview/performance", overviewArticle)

// Overview Risk
router.addRoute("/:accountValue/p/:portfolioAlias/overview/risk", {
  title: "Portfolio overview risk",
  url: `${SUPPORT_URL}/1144457-risk`,
})

// Security screener
router.addRoute("/:accountValue/home/market/securities", {
  title: "Security screener",
  url: `${SUPPORT_URL}/2966118-security-screening-saved-searches`,
})

// Factor leaderboard
router.addRoute("/:accountValue/home/market/factors/*", {
  title: "Factors leaderboard",
  url: `${SUPPORT_URL}/1144494-factors-leaderboard`,
})

// Portfolio Asset view
router.addRoute("/:accountValue/p/:portfolioAlias/analyze/assets*", {
  title: "Asset analytics",
  url: `${SUPPORT_URL}/6146157-asset-analytics`,
})

const factorSensitivityHelp = {
  title: "Factor sensitivity",
  url: `${SUPPORT_URL}/8490216-factor-sensitivity`,
}

// Portfolio Factor Sensitivty Trends
router.addRoute("/:accountValue/p/:portfolioAlias/analyze/trends/factor-sensitivity/*", factorSensitivityHelp)
// Portfolio Factor Sensitivty Assets
router.addRoute(/^\/\w*\/p\/\w*\/analyze\/assets\/(historical|predicted)-factor-sensitivity/, factorSensitivityHelp)

// Portfolio Performance
router.addRoute("/:accountValue/p/:portfolioAlias/analyze/trends/performance", {
  title: "Analyzing portfolio trends",
  url: `${SUPPORT_URL}/6264358-analyzing-portfolio-trends#h_cd7d116ee6`,
})

// Portfolio Risk
router.addRoute("/:accountValue/p/:portfolioAlias/analyze/trends/risk", {
  title: "Analyzing portfolio trends",
  url: `${SUPPORT_URL}/6264358-analyzing-portfolio-trends#h_4791efe1dd`,
})

// Portfolio Beta
router.addRoute("/:accountValue/p/:portfolioAlias/analyze/trends/composition", {
  title: "Beta trends",
  url: `${SUPPORT_URL}/4993824-managing-beta`,
})

// Portfolio Exposure
// Daily Exposure
router.addRoute("/:accountValue/p/:portfolioAlias/analyze/trends/exposure", ({ query }) => {
  if (get(query, "daily")) {
    return {
      title: "Daily exposure",
      url: `${SUPPORT_URL}/1144491-current-exposure`,
    }
  }

  return {
    title: "Analyzing portfolio trends",
    url: `${SUPPORT_URL}/6264358-analyzing-portfolio-trends#h_6606afacb6`,
  }
})

// Portfolio Analyze Factors
// Performance
router.addRoute("/:accountValue/p/:portfolioAlias/analyze/factors/performance", {
  title: "Analyze a portfolio's factor performance",
  url: `${SUPPORT_URL}/6840971-analyze-a-portfolio-s-factor-performance`,
})
// Risk
router.addRoute("/:accountValue/p/:portfolioAlias/analyze/factors/risk", {
  title: "Analyze a portfolio's factor risks",
  url: `${SUPPORT_URL}/6760178-analyze-factor-risks`,
})

// Compare screen
router.addRoute("/:accountValue/p/:portfolioAlias/analyze/compare/*", {
  title: "Side by side comparison",
  url: `${SUPPORT_URL}/3232259-side-by-side-comparison`,
})

// Optimizer
router.addRoute("/:accountValue/p/:portfolioAlias/rebalance/optimizer", {
  title: "Portfolio optimizer",
  url: `${SUPPORT_URL}/2549276-on-demand-optimizations`,
})

// Simulator
router.addRoute("/:accountValue/p/:portfolioAlias/rebalance/simulator", {
  title: "Trade simulator",
  url: `${SUPPORT_URL}/6150154-trade-simulator`,
})

// Experiments
router.addRoute("/:accountValue/p/:portfolioAlias/rebalance/experiments", {
  title: "Rebalance experiments",
  url: `${SUPPORT_URL}/3550049-managing-rebalance-experiments`,
})

// Research topic and Smart Trades
router.addRoute("/:accountValue/t/:researchTopicId/*", {
  title: "Managing hedge basket experiments",
  url: `${SUPPORT_URL}/5910108-portfolio-hedge-baskets`,
})

// Watchlist
router.addRoute("/:accountValue/watchlist/:watchlistId", {
  title: "Watchlists",
  url: `${SUPPORT_URL}/2966106-watchlists`,
})

// Members & Teams
// this has to be last to not override other routes
const membersHelp = {
  title: "Members & teams management",
  url: `${SUPPORT_URL}/5521425-teams-members`,
}

// ruta3.addRoute doesnt support multiple routes
router.addRoute("^/:accountValue/home/:type(members|teams)*", membersHelp)
router.addRoute("^/:accountValue/:resourceType/:portfolioAliasOrId/permissions/*", membersHelp)

// Analyzing composites
router.addRoute("^/:accountValue/composite/*", {
  title: "Analyzing composite securities",
  url: `${SUPPORT_URL}/6841014-analyzing-composite-securities`,
})

// Composite Factor Sensitivity Assets
router.addRoute(/^\/\w*\/composite\/[\w/]*\/assets\/(historical|predicted)-factor-sensitivity*/, factorSensitivityHelp)

// Composite Factor Sensitivity Trends
router.addRoute("/:accountValue/composite/*/trends/factor-sensitivity/*", factorSensitivityHelp)

// Composite Marginal Contribution view
router.addRoute("^/:accountValue/composite/*/assets/marginal*", {
  title: "Enhanced Risk Decompositions",
  url: `${SUPPORT_URL}/8156177-enhanced-risk-decompositions`,
})

// Assets marginal contribution
router.addRoute("^/:accountValue/p/*/analyze/assets/marginal", {
  title: "Enhanced Risk Decompositions",
  url: `${SUPPORT_URL}/8156177-enhanced-risk-decompositions`,
})

// Intraday marginal contribution
router.addRoute("^/:accountValue/p/*/analyze/intraday/assets/marginal", {
  title: "Enhanced Risk Decompositions",
  url: `${SUPPORT_URL}/8156177-enhanced-risk-decompositions`,
})

const defaultState = {}

router.addRoute("^/:accountValue/*", defaultState)

export default (state = defaultState, action) => {
  switch (action.type) {
    case Types.NAVIGATE: {
      let match = router.match(action.location.pathname)
      if (!match) {
        return state
      }
      const articles = []
      // Go through all the matching routes and append the articles
      while (match) {
        const article = isFunction(match.action) ? match.action(action.location) : match.action
        if (!isEmpty(article)) {
          articles.push(article)
        }
        match = match.next(action.location.pathname)
      }
      return articles
    }
    default:
      return state
  }
}
